"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileTypeIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _file = require("FileManagerCore/utils/file");

var _Constants = require("FileManagerCore/Constants");

var _Audio = _interopRequireDefault(require("FileManagerCore/components/icons/Audio"));

var _Document = _interopRequireDefault(require("FileManagerCore/components/icons/Document"));

var _ExcelFile = _interopRequireDefault(require("FileManagerCore/components/icons/ExcelFile"));

var _PDF = _interopRequireDefault(require("FileManagerCore/components/icons/PDF"));

var _Video = _interopRequireDefault(require("FileManagerCore/components/icons/Video"));

var _Image = _interopRequireDefault(require("FileManagerCore/components/icons/Image"));

var _WordFile = _interopRequireDefault(require("FileManagerCore/components/icons/WordFile"));

var WordExtensions = _immutable.default.Set(['doc', 'docx']);

var ExcelExtensions = _immutable.default.Set(['xls', 'xlsx', 'csv']);

function FileTypeIcon(props) {
  var file = props.file,
      other = (0, _objectWithoutProperties2.default)(props, ["file"]);
  var extension = file.get('extension');
  var type = file.get('type') ? file.get('type') : (0, _file.getType)(extension);
  var Icon;

  switch (type) {
    case _Constants.FileTypes.AUDIO:
      Icon = _Audio.default;
      break;

    case _Constants.FileTypes.MOVIE:
      Icon = _Video.default;
      break;

    case _Constants.FileTypes.DOCUMENT:
      if (extension === 'pdf') {
        Icon = _PDF.default;
      } else if (WordExtensions.includes(extension)) {
        Icon = _WordFile.default;
      } else if (ExcelExtensions.includes(extension)) {
        Icon = _ExcelFile.default;
      } else {
        Icon = _Document.default;
      }

      break;

    case _Constants.FileTypes.IMG:
      Icon = _Image.default;
      break;

    default:
      Icon = _Document.default;
  }

  return _react.default.createElement(Icon, (0, _extends2.default)({
    className: "file-type-icon"
  }, other));
}

FileTypeIcon.propTypes = {
  file: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired
};
module.exports = exports.default;